module.exports = __webpack_public_path__ + "static/img/A149.db5c4dda.jpg";